import { createFileRoute } from '@tanstack/react-router';

import { PhoneSetupCallHandlingPanel } from '@apps/web/components/settings/phone_setup/phone_setup_call_handling_panel';
import { PhoneSetupPageShell } from '@apps/web/components/settings/phone_setup/phone_setup_page_shell';
import {
    renderPhoneSetupRouteGuard,
    usePhoneSetupRoute,
} from '@apps/web/components/settings/phone_setup/use_phone_setup_route';

export const Route = createFileRoute('/_app/settings/phone')({
    component: PhoneSettingsPage,
});

function PhoneSettingsPage() {
    const routeState = usePhoneSetupRoute();

    return renderPhoneSetupRouteGuard(routeState, (ready) => (
        <PhoneSetupPageShell title="Call handling">
            <PhoneSetupCallHandlingPanel
                organizationId={ready.organizationId}
                organization={ready.organization}
                canManageOrgTelephony={ready.canManageOrgTelephony}
                mutateOrganization={ready.mutateOrganization}
            />
        </PhoneSetupPageShell>
    ));
}
